import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/forget-password`;

export default {
  forgotPassword(payload) {
    return Client.post(`${resource}/request`, payload);
  },
  checkForgotToken(payload) {
    return Client.post(`${resource}/check`, payload);
  },
  resetPassword(payload) {
    return Client.post(`${resource}/reset`, payload);
  },
};
